import { createRef, Component } from 'react';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import * as preferencesActions from '../../../actions/preferencesActions';
import * as trendingActions from '../../../actions/trendingBarActions';

import withComponentName from '../../../decorators/withComponentName';

import StorageSvc from '../../../services/StorageSvc';

import TrendingBarInner from '../TrendingBarInner';
import PlayVideoComponent from '../../PlayVideoComponent';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class TrendingBarWrapper extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      graphDropDown: false,
      animated: false,
      rendered: false,
    };
    this.trendingBar = createRef();
  }

  componentDidMount() {
    this.setState({
      rendered: true,
    });
  }

  componentDidUpdate(prevProps) {
    const { trendingGraphOpened, piwikEnabled } = this.props;

    // eslint-disable-next-line react/prop-types
    if (
      prevProps.trendingGraphOpened !== trendingGraphOpened
      && trendingGraphOpened
      && piwikEnabled
    ) {
      _paq.push(['trackEvent', 'Trending bar', 'Trending graph']);
    }
  }

  activateTrendingBar() {
    const {
      token,
      userPreferences,
      actions,
      piwikEnabled,
    } = this.props;
    if (token) {
      actions.onUserPreferencesUpdate({
        show_trending_asset_bar: !userPreferences.show_trending_asset_bar,
      }, token);
    } else {
      const guestPref = StorageSvc.getItem('userPreferences');
      actions.onUserPreferencesUpdate({
        show_trending_asset_bar: !guestPref.show_trending_asset_bar,
      });
    }

    if (piwikEnabled) _paq.push(['trackEvent', 'Trending bar', 'Trending activate']);
    this.setState({ animated: true });
  }

  closeTrendingBar() {
    const {
      actions, token, userPreferences, piwikEnabled,
    } = this.props;

    actions.trendingBarClosing();
    actions.onUserPreferencesUpdate({
      show_trending_asset_bar: !userPreferences.show_trending_asset_bar,
    }, token);
    actions.changeTrendingPeriod('hour1');
    actions.closeTrendingDropDowns();
    setTimeout(() => {
      actions.trendingBarClosing();
      actions.onLoadAssets();
    }, 1300);
    this.setState({ animated: true });

    if (piwikEnabled) _paq.push(['trackEvent', 'Trending bar', 'Trending deactivate']);
  }

  toggleTrendingGraph(e) {
    e.stopPropagation();

    const { actions } = this.props;
    actions.toggleTrendingGraph();
  }

  render() {
    const {
      userPreferences,
      trendingGraphOpened,
      user,
      piwikEnabled,
      isChatbotOpened,
    } = this.props;
    const { graphDropDown, animated, rendered } = this.state;

    const trendingActive = rendered && userPreferences.show_trending_asset_bar;

    const trendingBarClass = cx({
      trending_bar_wrapper: true,
      trending_active: trendingActive,
      trending_bar_animated: animated,
      'full-width': isChatbotOpened,
    });

    const disactivateBtnClass = cx({
      trending_disable_btn: true,
      'trending-disactivate-button': trendingActive,
    });

    const trendingGraphBtn = cx({
      trending_graph_btn: true,
      active: trendingGraphOpened,
    });

    return (
      <div className={cx('trending_bar_cutter', {
        active: trendingActive,
      })}
      >
        <div
          className={trendingBarClass}
          ref={this.trendingBar}
        >
          <div className={Styles.trending_activation_block}>
            <p className="m-0">
              <i />
              {' '}
              Trending
            </p>
            <PlayVideoComponent
              videoLink="https://cityfalcon.wistia.com/medias/be7nogrmi6"
              videoLinkMobile="https://cityfalcon.wistia.com/medias/be7nogrmi6"
              additionalStyles={cx('trending_play_button', { active: trendingGraphOpened })}
              renderOutside
            />
            <button type="button" onClick={this.activateTrendingBar}>Activate</button>
          </div>
          <TrendingBarInner trendingGraph={graphDropDown} user={user} piwikEnabled={piwikEnabled} />
          <div className={trendingGraphBtn} onClick={this.toggleTrendingGraph} />
          <div className={disactivateBtnClass} onClick={this.closeTrendingBar}>
            <FontAwesomeIcon icon={faXmark} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...preferencesActions, ...trendingActions }, dispatch),
});

const mapStateToProps = (state) => ({
  userPreferences: state.userPreferencesReducer.preferences,
  token: state.watchlistReducer.userToken,
  trendingClasses: state.trendingBarReducer.trendingClasses,
  trendingGraphOpened: state.trendingBarReducer.trendingGraphOpened,
  isChatbotOpened: state.chatbot.isChatbotOpened && (state.common.width > 1024 && state.common.width < 1500),
});

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(TrendingBarWrapper),
);
